var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "marTML",
        staticStyle: { background: "#f4f4f4" },
        attrs: { id: _vm.activity.sq_code + "-top" }
      },
      [
        _c(
          "p",
          {
            staticClass: "widM fntH6 fntL bold padTS padBS",
            staticStyle: { color: "#002060" }
          },
          [_vm._v(_vm._s(_vm.activity.title) + " 예약")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "widM marTML" },
      _vm._l(_vm.pairList, function(pair, pairIdx) {
        return _c("SurveyActivityPair", {
          key: _vm.activity.sq_code + "_pair_" + pairIdx,
          attrs: {
            "row-idx": pairIdx,
            "left-side": pair[0],
            "right-side": pair[1],
            activity: _vm.activity,
            "show-bottom-hr": pairIdx < _vm.pairList.length - 1
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07d0c9a8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07d0c9a8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyActivityParticipant.vue
// module id = null
// module chunks = 